module.exports = __webpack_public_path__ + "img/topstwl_bg.db236655.png";